import { BehaviorSubject } from "rxjs";

const alertSubject = new BehaviorSubject(null);

const isValidMessage = (message) =>
  typeof message === "string" && message.trim().length > 0;

const AlertService = {
  alert: alertSubject.asObservable(),

  success: (message) => {
    if (!isValidMessage(message)) return;

    alertSubject.next({
      severity: "success",
      summary: "Success",
      detail: message,
      life: 3000,
    });
  },

  info: (message) => {
    if (!isValidMessage(message)) return;

    alertSubject.next({
      severity: "info",
      summary: "Info",
      detail: message,
      life: 3000,
    });
  },

  sticky: (message) => {
    if (!isValidMessage(message)) return;

    alertSubject.next({
      severity: "info",
      summary: "Info",
      sticky: true,
      detail: message,
      life: 3000,
    });
  },

  error: (message, showAfterRedirect = false) => {
    if (!isValidMessage(message)) return;

    alertSubject.next({
      severity: "error",
      summary: "Error",
      detail: message,
      life: 3000,
      showAfterRedirect,
    });
  },

clear: () => {
  const current = alertSubject.value;

  if (!current) return;

  if (current.showAfterRedirect) {
    alertSubject.next({
      ...current,
      showAfterRedirect: false,
    });
  } else {
    alertSubject.next(null);
  }
},
};

export default AlertService;
